// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Carousel-module__root--m0p9x {
    border: 1px solid rgb(61, 68, 77);
    padding: 10px;
    text-align: center;
    width: stretch;
}
.Carousel-module__image--hyMbU {
    max-width: 100%;
    max-height: 200px;
}
.Carousel-module__description--frQLJ {
    max-width: 500px;
    word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/modules/carousel/Carousel.module.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;IACjC,aAAa;IACb,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B","sourcesContent":[".root {\n    border: 1px solid rgb(61, 68, 77);\n    padding: 10px;\n    text-align: center;\n    width: stretch;\n}\n.image {\n    max-width: 100%;\n    max-height: 200px;\n}\n.description {\n    max-width: 500px;\n    word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Carousel-module__root--m0p9x`,
	"image": `Carousel-module__image--hyMbU`,
	"description": `Carousel-module__description--frQLJ`
};
export default ___CSS_LOADER_EXPORT___;
